module.exports = __webpack_public_path__ + "static/media/29.91021766.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/29.jpg
// module id = 204
// module chunks = 0